<div class="container align-middle">
  <div><br></div>
  <div class="row justify-content-md-center">
    <mat-card class="card-div mb-3">
      <mat-card-content class="mat-typography" style="color: #041427">
        <div class="d-flex justify-content-center align-items-center card-content-div">
          <a href="https://apps.apple.com/us/app/integers-for-pre-algebra/id502423248#see-all/developer-other-apps">
            <img alt="" src="assets/images/apple.svg" width="250px" height="70px">
          </a>
        </div>
        <div class="card-content-div">
          <h3 style="color: #4372AA">
            <p align="justify">Click above for KSolve Apple App Store apps are for learning and testing various K12 STEM
              topics students. These applications will help and tutor you to master the subjects. Unlike books, these
              application are interactive. User interface is kept very simple and intuitive, so that no training is
              required to use these application. You can focus on learning subjects right away. Master the subject with
              instructor guided lessons, study aid flashcards and unlimited practice tests. All your practice test
              results are saved and can be reviewed for tracking progress. Once the application is installed, no
              internet access is needed, so learn anywhere on your phone or tablet, at home, school, in the park or on
              the go.</p>
          </h3>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="card-div mb-3">
      <mat-card-content class="mat-typography" style="color: #041427">
        <div class="d-flex justify-content-center align-items-center card-content-div">
          <a href="https://play.google.com/store/apps/developer?id=KSolve+LLC">
            <img alt="" alt="Android app on Google Play" src="assets/images/Get_it_on_Google_play.svg" width="250px"
              height="70px">
          </a>
        </div>
        <div class="card-content-div">
          <h3 style="color: #4372AA">
            <p align="justify">Click above KSolve Google Play Store apps are for learning and testing various K12 STEM
              topics students. These applications will help and tutor you to master the subjects. Unlike books, these
              application are interactive. User interface is kept very simple and intuitive, so that no training is
              required to use these application. You can focus on learning subjects right away. Master the subject with
              instructor guided lessons, study aid flashcards and unlimited practice tests. Once the application is
              installed, no internet access is needed, so learn anywhere on any of your android device at home, school,
              in the park or on the go.</p>
          </h3>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="card-div mb-3">
      <mat-card-content class="mat-typography" style="color: #041427">
        <div class="d-flex justify-content-center align-items-center card-content-div">
          <a
            href="http://www.amazon.com/s/ref=bl_sr_mobile-apps?_encoding=UTF8&field-brandtextbin=KSolve%20LLC&node=2350149011">
            <img alt="" alt="" src="assets/images/amazon.png" width="250px" height="70px">
          </a>
        </div>
        <div class="card-content-div">
          <h3 style="color: #4372AA">
            <p align="justify">Click above KSolve Amazon App Store apps are for learning and testing various K12 STEM
              topics students. These applications will help and tutor you to master the subjects. Unlike books, these
              application are interactive. User interface is kept very simple and intuitive, so that no training is
              required to use these application. You can focus on learning subjects right away. Master the subject with
              instructor guided lessons, study aid flashcards and unlimited practice tests. Once the application is
              installed, no internet access is needed, so learn anywhere on any of your android device at home, school,
              in the park or on the go.</p>
          </h3>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="card-div mb-3">
      <mat-card-content class="mat-typography" style="color: #041427">
        <div class="d-flex justify-content-center align-items-center card-content-div">
          <a
            href="http://www.amazon.com/s/ref=bl_sr_mobile-apps?_encoding=UTF8&field-brandtextbin=KSolve%20LLC&node=2350149011">
            <img alt="" class="img-logo" src="assets/images/ksolve.png">
          </a>
        </div>
        <h1>
          <p><b>KSolve Employee Onboaring System</b></p>
        </h1>
        <h3 style="color: #4372AA">
          <p align="justify">KSolve Employee Onboaring System (EOS) makes employee onboarding training process stress
            free, completely
            automated and stress free. KSolve EOS is infused with AI and
            available on web and mobile platforms.</p>
        </h3>
      </mat-card-content>
    </mat-card>
    <mat-card class="card-div mb-3">
      <mat-card-content class="mat-typography" style="color: #041427">
        <div class="d-flex justify-content-center align-items-center card-content-div">
          <a
            href="http://www.amazon.com/s/ref=bl_sr_mobile-apps?_encoding=UTF8&field-brandtextbin=KSolve%20LLC&node=2350149011">
            <img alt="" class="img-logo" src="assets/images/ksolve.png">
          </a>
        </div>
        <h1>
          <p><b>Custom Medical Image Management System</b></p>
        </h1>
        <h3 style="color: #4372AA">
          <p align="justify">KSolve Medical Image Management System (MIS) is extremely secure with end to end
            encryption and extremely versatile search capability. KSolve MIS is infused with AI and
            available on web and mobile platforms.</p>
        </h3>
      </mat-card-content>
    </mat-card>
  </div>
</div>